// Prey (como no Tibia): até 3 espaços. Cada um mostra uma lista de 9 criaturas; o jogador escolhe uma e ganha
// um bônus aleatório contra ela por 2 horas de caça. O 3º espaço é liberado na Noxara Store (decisão do Arthur).
// Prey cards (wildcards) trocam o bônus ou deixam escolher qualquer criatura.

export type PreyBonus = 'damage' | 'defense' | 'xp' | 'loot';
export const PREY_BONUS_NAMES: Record<PreyBonus, string> = {
  damage: 'Dano aumentado', defense: 'Dano recebido reduzido', xp: 'Experiência extra', loot: 'Loot melhor',
};
/** valor do bônus (%) por grau 1..10 (estrelas) */
export function preyValue(type: PreyBonus, grade: number): number {
  const g = Math.max(1, Math.min(10, grade)) - 1;
  return type === 'damage' ? 7 + g * 3 : type === 'defense' ? 12 + g * 3 : 13 + g * 3;
}
export const PREY_DURATION_S = 2 * 3600;        // 2 horas de caça
export const PREY_FREE_REROLL_MS = 20 * 3600_000; // lista nova grátis a cada 20 horas
export const PREY_LIST_SIZE = 9;
export const PREY_CARD_BONUS = 1;   // trocar só o bônus (mantém a criatura)
export const PREY_CARD_PICK = 5;    // escolher qualquer criatura
/** gold para trocar a lista antes das 20 horas */
export const preyRerollGold = (level: number) => Math.max(1, level) * 150;

export interface PreySlot {
  list: string[];
  monster?: string;
  bonus?: { type: PreyBonus; grade: number };
  /** segundos de caça que faltam */
  left?: number;
  /** quando a lista pode ser trocada de graça (ms) */
  freeAt: number;
}
export interface PreyState { slots: PreySlot[]; cards: number; third: boolean }

export const emptyPrey = (): PreyState => ({ slots: [], cards: 0, third: false });

/** Espaços liberados: 2 para todos, o 3º comprado na loja. */
export const preySlots = (s: PreyState) => (s.third ? 3 : 2);

/** Bônus ativo contra este monstro (nome base), se houver. */
export function preyFor(s: PreyState | undefined, monster: string): { type: PreyBonus; value: number } | null {
  for (const sl of s?.slots ?? []) {
    if (sl.monster === monster && sl.bonus && (sl.left ?? 0) > 0) return { type: sl.bonus.type, value: preyValue(sl.bonus.type, sl.bonus.grade) };
  }
  return null;
}
